define([
    "jquery",
    "underscore",
    "marionette",
    "forms/wallet/transfer_form",
    "behaviors/form_errors_behavior",
    "behaviors/modal_error_behavior",
    "backbone.syphon",
], function ($, _, Marionette, TransferModel, FormErrorsBehavior, ModalErrorBehavior) {
    let available_amount = 0;
    let formatted_available_amount = 0;
    let estimated_amount_time_out;
    let is_transferable_account = true;

    // when we initiate a transfer, we are not gonna user the result of the ongoing get until the transfer is finished
    let ignore_current_get = false;

    return Marionette.View.extend({
        el: '#content_layout',

        behaviors: {
            formErrors: {
                behaviorClass: FormErrorsBehavior
            },
            modalError: {
                behaviorClass: ModalErrorBehavior
            },
        },

        ui: {
            'form': '#form',
            'form_submit': '#form_submit',
            'form_submit_mobile': '#form_submit_mobile',
            'confirm_submit': '#confirm_transfer',

            'amount_pc': '#amount_pc',
            'amount_mobile': '#amount_mobile',
            'amount': '#amount',

            'mt_account_pc': '#mt_account_pc',
            'mt_account_mobile': '#mt_account_mobile',
            'mt_account' : '#mt_account',

            'mt_to_wallet': '#mt_to_wallet',
            'mt_to_wallet_pc': '#mt_to_wallet_pc',
            'mt_to_wallet_mobile': '#mt_to_wallet_mobile',
            'wallet_to_mt_pc': '#wallet_to_mt_pc',
            'wallet_to_mt_mobile': '#wallet_to_mt_mobile',
            'transfer_type': '#transfer_type',

            'wallet_amount': '#wallet_amount',
            'available_amount': '.available_amount',
            'estimated_amount': '.estimated_amount',
            'switch_transfer': '.switch_transfer',
            'margin_rate_text': '.margin_rate_text',
            'mt_to_wallet_helper': '.mt_to_wallet_helper',

            'wallet_to_mt': '.wallet_to_mt',
            'wallet_to_mt_helper': '.wallet_to_mt_helper',
            'origin_text': '.origin_text',
            'destination_text': '.destination_text',

            'transfer_apply_mt_to_wallet': '#transfer_apply_mt_to_wallet',
            'transfer_apply_wallet_to_mt': '#transfer_apply_wallet_to_mt',
            'transfer_completed_mt_to_wallet': '#transfer_completed_mt_to_wallet',
            'transfer_completed_wallet_to_mt': '#transfer_completed_wallet_to_mt',

            'transfer_alert': '#transfer_alert',
            'transfer_alert_message': '#transfer_alert_message',
        },

        events: {
            'click @ui.form_submit': 'check_form',
            'click @ui.form_submit_mobile': 'check_form',
            'click @ui.confirm_submit': 'initiate_transfer',
            'change @ui.mt_account': function () {
                available_amount = 0;
                formatted_available_amount = 0;
                this.reset_amount_fields();
                this.get_available_amount();
            },
            'change @ui.mt_account_pc': function () {
                available_amount = 0;
                formatted_available_amount = 0;
                this.reset_amount_fields();
                this.get_available_amount();
            },
            'click @ui.switch_transfer': 'switch_transfer',
            'click @ui.mt_to_wallet_pc': 'click_mt_to_wallet',
            'click @ui.wallet_to_mt_pc': 'click_wallet_to_mt',
            'click @ui.mt_to_wallet_mobile': 'click_mt_to_wallet',
            'click @ui.wallet_to_mt_mobile': 'click_wallet_to_mt',
        },

        initialize: function () {
            let that = this;
            setInterval(function () {
                that.get_available_amount();
            }, 30000);

            if ($(this.ui.mt_account_pc).val() || $(this.ui.mt_account_mobile).val()) {
                let temp_mt_account = $(this.ui.mt_account_pc).val() ?
                    $(this.ui.mt_account_pc).val() : $(this.ui.mt_account_mobile).val()
                $(this.ui.mt_account).val(temp_mt_account);

                this.get_available_amount();

                if ($(this.ui.amount).val()) {
                    that.get_estimated_amount();
                }
            }

            if ($(this.ui.transfer_type === 'mt_to_wallet')) {
              $(this.ui.available_amount).html("0");
            }

            this.block_submit_btn();
            this.responsive_value_handler();
        },

        responsive_value_handler: function(){
            let that = this;
            $(this.ui.amount_pc).on('change', function(e){
                if(e) e.preventDefault();
                $(that.ui.amount).val($(that.ui.amount_pc).val());
                $(that.ui.amount_mobile).val($(that.ui.amount_pc).val());
            });

            $(this.ui.amount_mobile).on('change', function(e){
                if(e) e.preventDefault();
                $(that.ui.amount).val($(that.ui.amount_mobile).val());
                $(that.ui.amount_pc).val($(that.ui.amount_mobile).val());
            });

            $(this.ui.mt_account_pc).on('change', function(e){
                if($(that.ui.mt_to_wallet_pc).is(':checked')) {
                    that.block_transfer($(that.ui.mt_account_pc).val());
                }
                $(that.ui.mt_account).val($(that.ui.mt_account_pc).val());
                $(that.ui.mt_account_mobile).val($(that.ui.mt_account_pc).val());
            });

            $(this.ui.mt_account_mobile).on('change', function(e){
                if($(that.ui.mt_to_wallet_mobile).is(':checked')) {
                    that.block_transfer($(that.ui.mt_account_mobile).val());
                }
                $(that.ui.mt_account).val($(that.ui.mt_account_mobile).val());
                $(that.ui.mt_account_pc).val($(that.ui.mt_account_mobile).val());
            });

            $(this.ui.amount_mobile).on('keyup', function(e){
                $(e.currentTarget).val($(e.currentTarget).val().replace(/[^0-9\.]+/g, ''));
                $(that.ui.amount).val($(that.ui.amount_mobile).val())
                $(that.ui.amount_pc).val($(that.ui.amount_mobile).val())
                that.time_out_get_estimated_amount();
            });

            $(this.ui.amount_pc).on('keyup', function(e){
                $(e.currentTarget).val($(e.currentTarget).val().replace(/[^0-9\.]+/g, ''));
                $(that.ui.amount).val($(that.ui.amount_pc).val())
                $(that.ui.amount_mobile).val($(that.ui.amount_pc).val())
                that.time_out_get_estimated_amount();
            });
        },

        get_available_amount: function () {
          let mt_account = $(this.ui.mt_account).val();
    
          if ($(this.ui.transfer_type).val() === "mt_to_wallet") {
            if (mt_account === "") {
              $(this.ui.available_amount).html("0");
              return;
            }
    
            let that = this;
            $.ajax("/rest_wallet/account_info", {
              method: "GET",
              data: {
                mt_account_no: mt_account,
              },
              success: function (data) {
                if (ignore_current_get) return;
    
                available_amount = data["available_amount"];
                formatted_available_amount = data["formatted_amount"];
                is_transferable_account = data["is_transferable_account"];
    
                if (!is_transferable_account) {
                  $("#form_submit").attr("disabled", true);
                  $("#form_submit_mobile").attr("disabled", true);
                }
    
                if ($(that.ui.transfer_type).val() === "mt_to_wallet") {
                  let html = formatted_available_amount;
                  $(that.ui.available_amount).html(html);
                }
              },
              error: function (xhr, textStatus, errorThrown) {
                if (errorThrown === "" || ignore_current_get) return;
                that.triggerMethod("fillErrorModalContent", xhr.responseJSON);
                that.triggerMethod("openErrorModal");
              },
            });
          }
        },

        get_estimated_amount: function () {
            let amount = $(this.ui.amount).val();
            let mt_account = $(this.ui.mt_account).val();
            let type_transfer = $(this.ui.transfer_type).val();

            if (!(amount >= 0) || mt_account === '') {
                return;
            }

            let that = this;
            $.ajax('/rest_wallet/estimated_amount', {
                method: "GET",
                data: {
                    "mt_account_no": mt_account,
                    "amount": amount,
                    "type_transfer": type_transfer
                },
                success: function (data) {
                    if (ignore_current_get) return;

                    $(that.ui.estimated_amount).val(data);
                },
                error: function (xhr, textStatus, errorThrown) {
                    if (errorThrown === '' || ignore_current_get) return;
                    that.triggerMethod('fillErrorModalContent', xhr.responseJSON);
                    that.triggerMethod('openErrorModal');
                }
            });
        },

        initiate_transfer: function (e) {
            $('#transfer_apply').modal('hide');
            $('#holdon-overlay').show();
            ignore_current_get = true;

            let type_transfer = $(this.ui.transfer_type).val();
            let that = this;
            $.ajax('/rest_wallet/transfer', {
                method: "POST",
                data: {
                    "mt_account": $(this.ui.mt_account).val(),
                    "amount": $(this.ui.amount).val(),
                    "transfer": type_transfer
                },
                success: function(data) {
                    // reset the form
                    $(that.ui.wallet_amount).html(data['wallet_amount']);
                    that.get_available_amount();
                    $(that.ui.amount).val('');
                    $(that.ui.estimated_amount).val('');
                    available_amount = 0;
                    formatted_available_amount = 0;

                    // prepare the modal content
                    if (type_transfer === 'mt_to_wallet') {
                        $(that.ui.transfer_completed_mt_to_wallet).show();
                        $(that.ui.transfer_completed_wallet_to_mt).hide();
                    } else {
                        $(that.ui.available_amount).html($(that.ui.wallet_amount).html());
                        $(that.ui.transfer_completed_mt_to_wallet).hide();
                        $(that.ui.transfer_completed_wallet_to_mt).show();
                    }

                    // show the modal
                    $('#holdon-overlay').hide();
                    $('#transfer_completed').modal('show');
                    ignore_current_get = false;
                },
                error: function (xhr, textStatus, errorThrown) {
                    // if (errorThrown === '') return;
                    $('#holdon-overlay').hide();
                    that.triggerMethod('fillErrorModalContent', xhr.responseJSON);
                    that.triggerMethod('openErrorModal');
                    ignore_current_get = false;
                }
            });
        },

        check_form: function (e) {
            e.preventDefault();

            this.triggerMethod('hide:errors');

            this.model = new TransferModel();
            let formData = Backbone.Syphon.serialize(this);
            this.model.set(formData);

            let errors = this.model.isValid(true, true);

            if (errors) {
                this.triggerMethod('show:errors', errors);
            } else {
                if ($(this.ui.mt_to_wallet_pc).is(':checked')) {
                    $(this.ui.transfer_apply_mt_to_wallet).show();
                    $(this.ui.transfer_apply_wallet_to_mt).hide();
                } else {
                    $(this.ui.transfer_apply_mt_to_wallet).hide();
                    $(this.ui.transfer_apply_wallet_to_mt).show();
                }
                $('#transfer_apply').modal('show');
            }
        },

        // to avoid sending multiple ajax request when the user is simply typing the amount
        time_out_get_estimated_amount: function () {
            clearTimeout(estimated_amount_time_out);
            let that = this;
            estimated_amount_time_out = setTimeout(function () {
                that.get_estimated_amount();
            }, 1000);
        },

        click_mt_to_wallet: function () {
            $(this.ui.mt_to_wallet_pc).prop('checked', true);
            $(this.ui.mt_to_wallet_mobile).prop('checked', true);

            $(this.ui.transfer_type).val('mt_to_wallet');
            $(this.ui.available_amount).html(formatted_available_amount);
            $(this.ui.margin_rate_text).removeClass('invisible');

            let origin = $(this.ui.switch_transfer).data('mt');
            let destination = $(this.ui.switch_transfer).data('wallet');
            $(this.ui.origin_text).html(origin);
            $(this.ui.destination_text).html(destination);
            $(this.ui.mt_to_wallet_helper).removeClass('invisible');
            $(this.ui.wallet_to_mt_helper).addClass('invisible');
            this.reset_amount_fields();

            let mt4_account_no = $(this.ui.mt_account_pc).val() ?
                    $(this.ui.mt_account_pc).val() : $(this.ui.mt_account_mobile).val();
            this.block_transfer(mt4_account_no)

            this.get_available_amount();
        },

        click_wallet_to_mt: function () {
            $(this.ui.wallet_to_mt_pc).prop('checked', true);
            $(this.ui.wallet_to_mt_mobile).prop('checked', true);

            $(this.ui.transfer_type).val('wallet_to_mt');
            $(this.ui.available_amount).html($(this.ui.wallet_amount).html());
            $(this.ui.margin_rate_text).addClass('invisible');

            let origin = $(this.ui.switch_transfer).data('wallet');
            let destination = $(this.ui.switch_transfer).data('mt');
            $(this.ui.origin_text).html(origin);
            $(this.ui.destination_text).html(destination);
            $(this.ui.mt_to_wallet_helper).addClass('invisible');
            $(this.ui.wallet_to_mt_helper).removeClass('invisible');
            this.reset_amount_fields();

            $('#transfer_alert').attr('hidden', true)
            $('#form_submit').attr('disabled', false);
            $('#form_submit_mobile').attr('disabled', false);
        },

        switch_transfer: function () {
            if ($(this.ui.transfer_type).val() === 'mt_to_wallet') {
                $(this.ui.wallet_to_mt_pc).prop('checked', true);
                $(this.ui.wallet_to_mt_mobile).prop('checked', true);
                this.click_wallet_to_mt();
            } else {
                $(this.ui.mt_to_wallet_pc).prop('checked', true);
                $(this.ui.mt_to_wallet_mobile).prop('checked', true);
                this.click_mt_to_wallet();
            }
        },

        reset_amount_fields: function () {
            $(this.ui.amount).val('');
            $(this.ui.amount_pc).val('');
            $(this.ui.amount_mobile).val('');

            $(this.ui.estimated_amount).val('');
        },

        block_submit_btn: function() {
            if(window.block_submit_btn && window.block_submit_btn == 'yes') {
                $('#form_submit').attr('disabled', true);
                $('#form_submit_mobile').attr('disabled', true);
            }
        },

        block_transfer: function(mt4AccountNo) {
            const account_info = window.accounts_info.find(a => a.mt4AccountNo == mt4AccountNo);
            if(account_info && account_info.canTransfer == false) {
                $('#transfer_alert').attr('hidden', false)
                $('#transfer_alert_message').text(`(${mt4AccountNo}) ${account_info.reasons[0]}`)
                $('#form_submit').attr('disabled', true);
                $('#form_submit_mobile').attr('disabled', true);
            }
            else {
                $('#transfer_alert').attr('hidden', true)
                $('#transfer_alert_message').text('')
                $('#form_submit').attr('disabled', false);
                $('#form_submit_mobile').attr('disabled', false);
            }
        },
    });
});